<template>
    <b-badge v-if="$safe(row,'Status') == 'UPLOADED'" variant="success">{{ $safe(row,'StatusName') }}</b-badge>
    <b-badge v-else-if="$safe(row,'Status') == 'WAITING_SIGNATURE'" variant="info">{{ $safe(row,'StatusName') }}</b-badge>
    <b-badge v-else-if="$safe(row,'Status') == 'CREATED'" variant="secondary">{{ $safe(row,'StatusName') }}</b-badge>
    <b-badge v-else variant="warning">{{ $safe(row,'StatusName') }}</b-badge>
</template>

<script>
import {BBadge} from 'bootstrap-vue'
import moment from 'moment'
export default {
    components:{
        BBadge
    },
    props:{
        row:Object,
        field:[Object,String,Array,Number]
    },
    methods:{
        getDate(date){
            return moment(date).locale('tr').format('DD.MM.YYYY')
        }
    }
}
</script>

<style>

</style>